import React from 'react';
import { PROBLEM_CARDS } from '../data/content';
import { Overline } from './Overline';
export function ProblemSection() {
  return <section className="bg-cream py-24 lg:py-32" data-id="element-303" data-mp="2ltwahol6icuz">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-304" data-mp="30gxvo1selnov">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-305" data-mp="30iiptqat34m7">
          <div className="lg:col-span-5" data-id="element-306" data-mp="2vpg4g5g6n1h3">
            <Overline data-id="element-307" data-mp="2voehp3pt0qjj">El punto de partida</Overline>
            <h2 className="mt-6 font-serif text-[2.1rem] font-light leading-[1.1] text-ink sm:text-[2.6rem]" data-id="element-308" data-mp="39guo8ehwz6p7">
              Cambiar el suelo parece sencillo… hasta que empiezan los “extras”
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 lg:pt-16" data-id="element-309" data-mp="3jfjvzeg3jarq">
            <p className="text-[15px] leading-relaxed text-stone-600" data-id="element-310" data-mp="3egpeqgxs1u9q">
              Muchas instalaciones empiezan con un precio atractivo y terminan con dudas, retrasos,
              remates pendientes o decisiones improvisadas. El problema no suele ser el suelo: es la
              falta de planificación.
            </p>
          </div>
        </div>

        <ul className="mt-16 grid gap-px overflow-hidden rounded-3xl bg-ink/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-311" data-mp="jb0prhsjhec5">
          {PROBLEM_CARDS.map(card => <li key={card.title} className="flex flex-col gap-3 bg-cream p-8 transition-colors duration-200 ease-premium hover:bg-sand/60 lg:p-10" data-id="element-312" data-mp="scqprc0hlllj">
              <span className="font-serif text-xl leading-snug text-ink" data-id="element-313" data-mp="124e9srups0cz">{card.title}</span>
              <span className="text-[13.5px] leading-relaxed text-stone-600" data-id="element-314" data-mp="1726buep2p2uw">{card.text}</span>
            </li>)}
          <li className="flex flex-col justify-center gap-2 bg-sand p-8 lg:p-10" data-id="element-315" data-mp="1c33usthwq0xg">
            <span className="font-serif text-lg leading-snug text-ink" data-id="element-316" data-mp="1g3nti1i4pclp">
              Todo esto se evita antes de empezar, no durante la obra.
            </span>
            <a href="#sistema" className="mt-1 inline-flex w-fit border-b border-walnut/40 pb-0.5 text-[12.5px] font-medium tracking-wide text-walnut transition-colors duration-200 ease-premium hover:border-walnut" data-id="element-317" data-mp="3dvi79d1omd6h">
              Ver cómo lo resolvemos
            </a>
          </li>
        </ul>
      </div>
    </section>;
}